import {Component, OnInit} from "@angular/core";
import * as ThumborUrlBuilder from "thumbor-url-builder";
import {Field} from '../../models/field.model';
import {SharedDataService} from "../../../../services/shared/shared-data.service";
import {saveAs} from 'file-saver';
import {ENVIRONMENT} from "../../../../../environments/environment";
import {DomSanitizer} from "@angular/platform-browser";
import * as DOMPurify from "dompurify";
import {Router} from "@angular/router";
import exifr from '@evshiron/exifr';

@Component({
	selector: "tig-form-file-upload",
	styleUrls: ["form-file-upload.component.css"],
	templateUrl: 'form-file-upload.component.html'
})
export class FormFileUploadComponent extends Field implements OnInit {
	BOO_file_loaded: boolean = false;
	BOO_in_filesystem: boolean = false;
	BOO_edit: boolean = false;

	OBJ_thumbor_url_builder;
	STR_url = null;
	STR_route_to_self = "";
	STR_resized_image = null;
	STR_uploaded_file = null;
	allowed_files: string;
	private regex_allowed_files: RegExp;

	constructor(
		private OBJ_router: Router,
		private OBJ_shared_Service: SharedDataService,
		private sanitizer: DomSanitizer
	) {
		super();
	}

	/**
	 * Lifecycle > ngOnInit
	 */
	ngOnInit(): void {
		// image upload allowed
		if (this.OBJ_field_config.readonly != null && this.OBJ_field_config.readonly == false) {
			this.BOO_edit = true;
		}

		// Dateiupload
		if (this.OBJ_field_config.file) {
			if (typeof this.OBJ_field_config.allowed_files !== 'undefined') {
				this.regex_allowed_files = new RegExp(this.OBJ_field_config.allowed_files, 'i');
				this.allowed_files = ".csv";
			} else {
				this.regex_allowed_files = /application\/(vnd.openxmlformats-officedocument.wordprocessingml.document|pdf|xml)|text\/(calendar|xml)$/i;
				this.allowed_files = ".pdf,.docx,.ics,.xml";
			}
		}
		// Bildupload
		else {
			this.regex_allowed_files = /image\/(jpeg|png|gif|svg\+xml)$/i;
		}

		// Objekt mit Wert befuellt
		if (
			this.OBJ_field_config.value != null &&
			typeof this.OBJ_field_config.value === 'string'
		) {
			this.BOO_in_filesystem = true;
			this.BOO_file_loaded = true;

			let STR_wcms = "";

			if (ENVIRONMENT.env === 'development') {
				STR_wcms = 'wcms/';
			}

			// Detailansicht User
			let BOO_is_user_url = this.OBJ_router.url.includes('/users/users/');

			this.STR_url = this.OBJ_field_config.value.startsWith("https://") ? this.OBJ_field_config.value : "https://" + this.OBJ_field_config.value;

			// Dateiupload
			if (this.OBJ_field_config.file) {
				// If this is an assignment offer the user a link to the assigned object
				if (this.OBJ_field_config.object_structure && !BOO_is_user_url) {
					this.STR_route_to_self = STR_wcms + 'upload/files/' + this.OBJ_field_config.object_structure.ids[0];
				}
			}
			// Bildupload
			else {
				this.OBJ_thumbor_url_builder = new ThumborUrlBuilder("infinity", this.OBJ_field_config.domain);

				this.STR_resized_image = "https://" + this.OBJ_thumbor_url_builder.setImagePath(this.OBJ_field_config.value).
					// Passe Bild auf Box der Hoehe 150px an
					fitIn(0, 150).buildUrl();

				// If this is an assignment offer the user a link to the assigned object
				if (this.OBJ_field_config.object_structure && !BOO_is_user_url) {
					this.STR_route_to_self = STR_wcms + 'upload/images/' + this.OBJ_field_config.object_structure.ids[0];
				}
			}
		}
	}


	/**
	 * Function > fileChangeListener
	 * @param $OBJ_event
	 */
	fileChangeListener($OBJ_event): void {
console.log($OBJ_event.dataTransfer);
		let OBJ_file: File = $OBJ_event.dataTransfer ? $OBJ_event.dataTransfer.files[0] : $OBJ_event.target.files[0];

		// Datei hochgeladen
		if (OBJ_file != null) {
			if (this.regex_allowed_files.source.indexOf("image") !== -1){
				exifr.parse(OBJ_file)
				  .then(function(output){
				let inputValue =document.querySelector('input[ng-reflect-name="source"]') as HTMLInputElement;
if (inputValue == null) {
					let inputValue =document.querySelector('input[placeholder="Quelle"]') as HTMLInputElement;
				}
if (inputValue == null) {
					let inputValue =document.querySelector('input[placeholder="source"]') as HTMLInputElement;
				}
				if (inputValue != null && inputValue.value == "" && output.hasOwnProperty('Copyright') &&  typeof output.Copyright !== 'undefined'  && output.Copyright !="undefined" && output.Copyright !=""  )
						inputValue.value = output.Copyright;
				});
			}

			let OBJ_file_reader: FileReader = new FileReader();
			let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);

			// Zum anzeigen beim Fileupload
			this.OBJ_field_config.filename = OBJ_file.name;
			this.OBJ_field_config.value = OBJ_file;

			// Nicht erlaubtes Dateiformat hochgeladen
			if (!OBJ_file.type.match(this.regex_allowed_files)) {
				// set error
				if (this.OBJ_field_config.file) {
					OBJ_form_control.setErrors({"invalidFileFormat": true});
				} else {
					OBJ_form_control.setErrors({"invalidImageFormat": true});
				} // end if

				OBJ_form_control.markAsDirty();

				// reset config
				this.OBJ_field_config.value = null;
				this.BOO_file_loaded = false;
				this.STR_url = null;

				// abort
				return;
			} else {
				OBJ_form_control.setErrors(null);
			} // end if

			OBJ_file_reader.onloadend = (OBJ_load_event: any) => {
				let value = this.escape(OBJ_file_reader.result as string);

				this.STR_uploaded_file = this.sanitizer.bypassSecurityTrustUrl(this.escape(OBJ_file_reader.result as string));

				this.BOO_file_loaded = true;

				if (value.startsWith("data:")) {
					this.BOO_in_filesystem = false;
				} // end if

			};

			if (OBJ_file != null) {

				if (OBJ_file.type.startsWith('image')) {
					OBJ_file_reader.readAsDataURL(OBJ_file);
				} else {
					this.STR_url = " ";
					this.BOO_file_loaded = true;
					this.BOO_in_filesystem = false;
				}

			} // end if

			// Schicke Benachrichtigung, dass Wert sich geaendert hat. Alle Felder, die sich ueber sharedDataService subscribed haben, koennen nun drauf reagieren
			this.valueChanged(this.OBJ_field_config.filename);
		}
	}


	/**
	 * Function > reset
	 */
	reset(): void {

		this.OBJ_field_config.value = null;
		this.BOO_file_loaded = false;
		this.OBJ_form_group.get(this.OBJ_field_config.name).setErrors(null);
		// Wert hat sich geaendert
		this.valueChanged(null);
	}


	/**
	 * Function > onDrop
	 * @param $OBJ_event
	 */
	onDrop($OBJ_event): void {
		$OBJ_event.preventDefault();
		this.fileChangeListener($OBJ_event);
	}


	/**
	 * Function > onDragOver
	 * @param $OBJ_event
	 */
	onDragOver($OBJ_event): void {
		$OBJ_event.stopPropagation();
		$OBJ_event.preventDefault();
	} // end function onDragOver

	/**
	 * Function > download
	 */
	download(STR_path: string) {
		if (STR_path !== undefined && this.BOO_in_filesystem) {
			let ARR_Pathparts = STR_path.split('/');
			let STR_name = ARR_Pathparts[ARR_Pathparts.length - 1];
			STR_path = 'https://' + STR_path;
			saveAs(STR_path, STR_name);
		}
	}

	/**
	 * Function > escape IMG content
	 * @param STR_content
	 */
	escape(STR_content: string) {
		if (STR_content !== "") {
			let ARR_svg_Content = STR_content.split(',');
			if (ARR_svg_Content[0].split('/')[1].startsWith('svg+xml')) {
				let svg_content = atob(ARR_svg_Content[1]);
				let svg_cleancontent = DOMPurify.sanitize(svg_content, {USE_PROFILES: {svg: true, svgFilters: true}});
				return ARR_svg_Content[0] + ',' + btoa(svg_cleancontent);
			} else {
				return STR_content;
			} // end if
		} else {
			return "";
		}
	}

	/**
	 * Function > setValueManually
	 *
	 * @desc Because value is not set automatically an dirty not updated we set this manually
	 */
	valueChanged(value) {
		// Schicke Benachrichtigung, dass Wert sich geaendert hat. Alle Felder, die sich ueber sharedDataService subscribed haben, koennen nun drauf reagieren
		this.OBJ_shared_Service.sendValue(this.OBJ_field_config.name, value);
		let OBJ_form_control = this.OBJ_form_group.get(this.OBJ_field_config.name);
		// set FormControl to dirty
		OBJ_form_control.markAsDirty()
	}
}
